import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../utils/services/api.service';
import { AppService } from 'src/app/utils/services/app.service';
import { LoaderService } from 'src/app/utils/services/loader.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  public count: any;
  public CategoryName: any;
  public userData = JSON.parse(localStorage.getItem("userInfo"));
  constructor(
    private apiService: ApiService,
    private appService: AppService,
    private LoaderService:LoaderService
  ) {
    this.appService.listen().subscribe((res:any) => {
      this.CategoryName = res;
    });
  }

  ngOnInit() {
    this.LoaderService.showLoader()
    this.getAllCount();
    this.getAllCategoryName();
  }

  getAllCount() {
    const data ={
      role:localStorage.getItem("role"),
      id:localStorage.getItem("id")
    }
    this.apiService.getAllDashboardCount(data).subscribe((resp: any) => {
      if(resp.success) {
        this.LoaderService.hideLoader()
        this.count = resp;
      }
    });
    this.LoaderService.hideLoader()

  }

  getAllCategoryName() {
    this.apiService.getAllCategory().subscribe((res: any) => {
      if(res.success) {
        this.LoaderService.hideLoader()

        this.CategoryName = res;
      } else {
        this.LoaderService.hideLoader()

        console.log("Problem Getting Category Names");
      }
    });
  }
}
